import React from 'react';
import { Analytics } from '../../clients/Analytics';

export class SearchResult extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleDownloadClick = this.handleDownloadClick.bind(this);
    }

    componentDidMount() {
        this.analytics = new Analytics();
    }

    handleDownloadClick() {
        this.analytics.trackEvent({'category': 'subs', 'action': 'download', 'label': this.props.id});
        window.location = this.props.downloadUrl;
    }

    render() {
        return (
            <li className="searchResult">
                <div className="row">
                    <div className="col-md-10 col-sm-10 col-xs-10">
                        <span className="searchResultTitle">
                            { this.props.title }
                        </span>

                        <div className="searchResultDescription">
                                { this.props.description }
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-2 col-xs-2">
                        <button className="btn btn-primary pull-right" onClick={this.handleDownloadClick}>
                            <span className="glyphicon glyphicon-download" aria-hidden="true" /> Download
                        </button>
                    </div>
                </div>
            </li>
        );
    }
}


// WEBPACK FOOTER //
// ../components/SearchResult/SearchResult.jsx